import { withTheme } from '@pitchero/react-ui';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import ReactSlider from 'react-slider';
import styled from 'styled-components';

const SliderRoot = styled.div`
  & > div {
    height: 50px;
    margin: auto;
  }
`;

const SliderThumb = styled.div`
  cursor: pointer;
  position: absolute;
  z-index: 100;
  width: 90px;
  height: 12px;
  background: ${(props) => props.color};
  border-radius: 4px;
  border: 1px solid white;
  outline: none;
`;

const SliderTrack = styled.div`
  position: relative;
  background-color: rgba(255, 255, 255, 0.3);
  height: 2px;
  top: 5px;
`;

const Slider = ({ value, min, max, onChange, uiTheme }) => {
  const primary = get(uiTheme, 'colors.primary', '#fff');
  return (
    <SliderRoot>
      <ReactSlider
        min={min}
        max={max}
        onChange={onChange}
        value={value}
        renderThumb={(props) => <SliderThumb color={primary} {...props} />}
        renderTrack={(props) => <SliderTrack {...props} />}
      />
    </SliderRoot>
  );
};

Slider.propTypes = {
  value: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  max: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  uiTheme: PropTypes.shape({}),
};

Slider.defaultProps = {
  uiTheme: {},
};

export default withTheme(Slider);
